import { z } from 'zod';

export const CountryScalarFieldEnumSchema = z.enum(['id','countryName','callingCode','iso3','postalFirst','hasStateInAddress','postalFormat','states']);

export default CountryScalarFieldEnumSchema;
